(function($) {

    var isIE = '-ms-scroll-limit' in document.documentElement.style && '-ms-ime-align' in document.documentElement.style;

    if ($('.page-template-template-calculators').length) {
        $('.calculator-page .page-nav li').on('click', function() {
            var target = $(this).data('scroll');
            var offset = $('.calculator-page [data-scroll-position="'+target+'"]').offset().top - $('header').outerHeight();
            $('html, body').animate({ scrollTop: offset }, 300);
        })

        $(window).on('scroll', function() {
            if ((window.innerHeight + window.scrollY) >= document.body.offsetHeight) {
                $('.calculator-page .page-nav li').removeClass('active');
                $('.calculator-page .page-nav li').last().addClass('active');
            }
        })

        window.addEventListener('DOMContentLoaded', () => {
            if (!isIE) {
                var observer = new IntersectionObserver(function (entries) {
                    entries.forEach(entry => {
                        let target = $(entry.target).data('scroll-position');

                        if (entry.isIntersecting) {
                            $('.calculator-page .page-nav li[data-scroll="'+target+'"]').addClass('active');
                        } else {
                            $('.calculator-page .page-nav li[data-scroll="'+target+'"]').removeClass('active');
                        }
                    });
                }, {
                    rootMargin: '0px',
                    threshold: 0.25
                });

                $('.calculator-page [data-scroll-position]').each(function(index, el) {
                    observer.observe(el);
                });
            }
        });
    }

})( jQuery );